<template>
  <div class="pb-16">
    <TitleLogo title="마이페이지" />

    <!-- 목록 -->
    <v-sheet>
      <!-- 탭 제목 -->
      <v-tabs v-model="tabs" color="primary" fixed-tabs @change="refreshTabContent">
        <v-tab v-for="item in menu" :key="item.title" width="50%" class="text-subtitle-1 font-weight-medium">
          {{ item.title }}
        </v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <!-- 탭 본문 -->
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <MyHistory ref="myHistory" />
        </v-tab-item>
        <v-tab-item>
          <MyPicture ref="myPicture" />
        </v-tab-item>
        <v-tab-item>
          <Update ref="myInfo" />
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>
  </div>
</template>
<script>
import MyHistory from "./components/MyHistory"
import MyPicture from "./components/MyPicture"
import Update from "./components/Update"
import TitleLogo from "@/views/components/TitleLogo"

export default {
  components: {
    MyHistory,
    MyPicture,
    Update,
    TitleLogo,
  },

  data: () => ({
    tabs: null,
    menu: [
      {
        title: "촬영일지",
        path: "/mypage/home?type=shotlist",
      },
      {
        title: "공주의 앨범",
        path: "/mypage/home?type=picture",
      },
      {
        title: "내 정보",
        path: "/mypage/home?type=update",
      },
    ],
  }),

  created() {
    // 비 로그인 시
    if (!this.$store.state.lafia_user.is_logined) {
      alert("마이페이지는 로그인 후 이용가능합니다.")
      this.$router.push("/auth/login")
    }

    switch (this.$route.query.type) {
      case "reservation":
      case "shotlist":
        this.tabs = 0
        break
      case "picture":
        this.tabs = 1
        break
      case "update":
        this.tabs = 2
        break
    }
  },

  methods: {
    refreshTabContent() {
      switch (this.tabs) {
        case 1:
          this.$refs.myPicture?.load()
          break
      }
    },
  },
}
</script>
<style scoped>
.banner {
  /* background: url('~@/assets/list_main.svg'); */
  background-size: 100%;
}
.v-tab--active {
  color: black;
}
</style>
